import React, { useReducer } from 'react'
import ConnectContext from './connectContext'
import ConnectReducer from './connectReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'
import { RESPONSE_STATUS, CLEAR_RESPONSE, GET_CONNECT_SESSION } from './connectTypes'

const ConnectState = (props) => {
    const initialState = {
        connectSession: null,
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(ConnectReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getConnectSession = async (formData) => {
        let from = 'sessionkey'
        try {
            const [res] = await Promise.all([apiCall('post', 'session', formData, '', 'connect')])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_CONNECT_SESSION,
                    payload: {
                        client_secret: res.data.data.responseData.client_secret,
                    },
                })
                return res.data.data.responseData.client_secret
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <ConnectContext.Provider
            value={{
                responseStatus: state.responseStatus,
                connectSession: state.connectSession,
                getConnectSession,
                clearResponse,
            }}
        >
            {props.children}
        </ConnectContext.Provider>
    )
}

export default ConnectState
